import { useState, useEffect } from 'react'
import { chakra, Flex, Box, Grid, Image, GridItem } from '@chakra-ui/react'
import { useLanguageContext } from './../../context/locale.context'
import ActionPanel from '../../containers/action-panel/action-panel'
import WorkspacePanel from './../../containers/workspace-panel/workspace-panel'
import OriginFormPanel from './../../containers/form-panel/form-panel'
import { useSharedContext } from './../../context/shared.context'
import { sharedConst } from '../../utils/action.constant'
import { MdCenterFocusWeak, MdTimelapse, MdUpdate } from 'react-icons/md'
import { GoMention } from 'react-icons/go'
import { ImStack } from 'react-icons/im'
import { useAuthContext } from '../../context/auth.context'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import { ParticipantContextProvider } from '../../context/participant-tab.context'

const VIEW = {
	WORKSPACE_VIEW: 'WORKSPACE_VIEW',
	FORM_VIEW: 'FORM_VIEW',
	LOADER_VIEW: 'LOADER_VIEW',
}

const Requests = () => {
	const {
		state: { locale },
	} = useLanguageContext()
	const location = useLocation()
	const [panelView, setpanelView] = useState(VIEW.WORKSPACE_VIEW)

	const {
		state: { queue },
		dispatch,
	} = useSharedContext()
	const {
		state: { authData },
	} = useAuthContext()
	const doRefresh = (i = 0) => {
		let timer = setTimeout(() => {
			// console.log('refresh ===> ', i, new Date().toLocaleString())
			dispatch({
				type: sharedConst.SHOW_LOADER,
			})
			dispatch({
				type: sharedConst.REFRESH_TIMELINE,
			})
			doRefresh(i + 1)
		}, 3000)
		if (i > 3) {
			clearTimeout(timer)
			//setpanelView(VIEW.WORKSPACE_VIEW);
			dispatch({
				type: sharedConst.REFRESH_LISTING,
			})
			dispatch({
				type: sharedConst.REFRESH_TIMELINE,
			})
			dispatch({
				type: sharedConst.HIDE_LOADER,
			})
		}
	}

	const staticQueueList = [
		{
			queue_name: locale['Focus List'],
			queue_id: 'MY_FOCUS',
			isStatic: true,
			icon: MdCenterFocusWeak,
			color: '#F7B017',
			flag: 3, //1
			isStatusFilter: 0,
			key: 'count_focus',
			title: locale['List that needs Immediate Focus'],
			path: '/focus',
			filterFlag: 3,
		},
		{
			queue_name: locale['My updates'],
			queue_id: 'UNREAD',
			isStatic: true,
			icon: MdUpdate,
			color: 'brand.800',
			flag: 11,
			isStatusFilter: 0,
			key: 'count_unread',
			title: locale['My Updates'],
			path: '/updates',
			filterFlag: 1,
		},
		{
			queue_name: locale['Mentions'],
			queue_id: 'MENTIONS',
			isStatic: true,
			icon: GoMention,
			color: 'orange.400',
			flag: 7,
			isStatusFilter: 0,
			key: 'count_mention',
			title: locale['Mentioned'],
			path: '/mentions',
			filterFlag: 2,
		},
		{
			queue_name: locale['Delayed'],
			queue_id: 'DELAYED',
			isStatic: true,
			icon: MdTimelapse,
			color: 'red.500',
			flag: 6,
			isStatusFilter: 0,
			key: 'count_pastdue',
			title: locale['Your delayed list'],
			path: '/delayed',
			filterFlag: 4,
		},
		{
			queue_name: locale['My Files'],
			queue_id: 'MY_QUEUE',
			isStatic: true,
			icon: ImStack,
			color: 'brand.800',
			flag: 0,
			isStatusFilter: 1,
			title: locale['List of My files'],
			path: '/requests',
		},
	]

	let paths = window.location.href

	useEffect(() => {
		staticQueueList.map(item => {
			if (location.pathname === item.path) {
				dispatch({
					type: sharedConst.SET_SELECTED_QUEUE,
					queue: item,
					isFirst: false,
				})
				return null
			} else {
				return null
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch])
	return (
		<Grid w='100%' templateColumns='repeat(3, 1fr)'>
			<GridItem colSpan={1} h='calc(100vh - 100px)'>
				<Flex bg='gray.500' flexDirection='column' h='100%'>
					<Box h='calc(100% - 50px)'>
						<ActionPanel
							openFormView={() => setpanelView(VIEW.FORM_VIEW)}
							queue={queue}
							openActivityView={() => setpanelView(VIEW.WORKSPACE_VIEW)}
						/>
					</Box>
				</Flex>
			</GridItem>
			<GridItem colSpan={2} h='calc(100vh - 100px)'>
				<Box h='100%'>
					{panelView === VIEW.WORKSPACE_VIEW ? (
						<ParticipantContextProvider>
							<WorkspacePanel />
						</ParticipantContextProvider>
					) : panelView === VIEW.FORM_VIEW ? (
						<OriginFormPanel
							onClose={() => {
								setpanelView(VIEW.WORKSPACE_VIEW)
								doRefresh(0)
							}}
							panelV={panelView}
						/>
					) : (
						''
					)}
				</Box>
			</GridItem>
		</Grid>
	)
}

export { Requests }
